
export default class XrayDataComponent {
	constructor() {
		this.template = `<div ng-non-bindable id="ng-xray-data"></div>`;
		this.controller = XrayDataController;
		this.bindings = {
			packageId: '@',
			version: '@',
			packageType: '@',
            path: '@',
            isLatestBuildVersion: '=?',
            latestBuild: '=?'
		};
	}
}

class XrayDataController {
	constructor() {

	}

	$onInit() {
        this.version =  this.version ||'';
        this.path =  this.path || '';
        const template = `<XrayDataContainer 
                package_id="${this.packageId}"
                version = "${this.version}"
                package_type="${this.packageType}"
                isLatestBuildVersion="${this.isLatestBuildVersion}"
                latest-build='${this.latestBuild}'
                path="${this.path}">                
            </XrayDataContainer>`;

        new Vue({
			el: '#ng-xray-data',
			template ,
            store: window.store,
            router: $vueRouter,

        });
	}
}



// WEBPACK FOOTER //
// ./ui_components/xray_data/xray.data.component.js